import { RouteComponentProps, useLocation } from '@gatsbyjs/reach-router'
import { APCard, APColumn, APImage, APPalette, APRow, APSizedBox, APText, getIt, handleErrorMessage } from 'ap-components'
import { useEffect, useState } from 'react'
import MutualFundApiServices from '../../Services/MutualFundServices'

export default function Notify(_props: RouteComponentProps) {
    const location = useLocation();
    const token = new URLSearchParams(location.search).get("tkn");
    const [message, setMessage] = useState<string>()

    async function makeApiCall() {
        if (!token) {
            return;
        }

        try {
            const response = await getIt(MutualFundApiServices).notifyClientForNRITinUpdate(token)
            const { email } = response;
            setMessage(email ? `Email ${email}` : '');
        } catch (error) {
            handleErrorMessage(error);
        }
    }

    useEffect(() => {
        makeApiCall();
    }, [token])

    if (!message || !token) {
        return (
            <div>Loading...</div>
        )
    }

    return (
        <APColumn mainAxisSize='max' crossAxisAlignment='stretch' mainAxisAlignment='center' style={{ width: "100vw" }}>
            <APColumn crossAxisAlignment='center'>
                <APRow mainAxisSize="min" crossAxisAlignment="start">
                    <APCard>
                        <APColumn crossAxisAlignment="center" gap="24px">
                            <APImage src="/icons/greenCheck.svg" height="80px" width="80px" />
                            <APColumn gap="8px" style={{ maxWidth: "320px" }}>
                                <APText variant="h1">Notification Sent</APText>
                                <APText center>Notification has been successfully sent to your client via {message}</APText>
                            </APColumn>
                        </APColumn>
                    </APCard>
                </APRow>
            </APColumn>
        </APColumn>
    )
}